exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-logo[data-v-5eaf5c88]{margin-right:5px}.v-avatar[data-v-5eaf5c88]{margin:auto}", ""]);

// exports
